import React from 'react';

export const MCSAWelcome = () => {
    return (
        <iframe
            title="Welcome"
            src="/mcsa_htmls__TBD/welcome.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
